module.exports = __webpack_public_path__ + "static/media/chat-icon.1b7ea067.png";